import { render, staticRenderFns } from "./WhatWeDoSection.vue?vue&type=template&id=8df71f80&scoped=true"
import script from "./WhatWeDoSection.vue?vue&type=script&lang=js"
export * from "./WhatWeDoSection.vue?vue&type=script&lang=js"
import style0 from "./WhatWeDoSection.vue?vue&type=style&index=0&id=8df71f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df71f80",
  null
  
)

export default component.exports